import React, { useCallback } from "react";

import { Box, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

import { Input } from "../../../../../../components/Form";
import ImageInput from "../../../../../../components/Form/ImageInput";
import ActionButtons from "../../../../../../components/Generic/ActionButtons";
import Breadcrumb from "../../../../../../components/Generic/Breadcrump";
import SkeletonComponent from "../../../../../../components/Generic/Skeleton";
import { Logo } from "../../../../../../models/company";
import { useActions } from "./hooks/useAction";
import useStyles from "./styles";

const SignaturePage = () => {
  const classes = useStyles();
  const { t: translate } = useTranslation();
  const {
    signature: logo,
    signatureToUpdate: signature,
    setSignatureToUpdate: setSignature,
    setSignature: setLogo,
    isFetching,
    hasFormBeenChanged,
    isLoading,
    setHasFormBeenChanged,
    onCancelSignature,
    onSaveSignature,
  } = useActions();

  const handleUpdateSignature = useCallback((attribute: string, value: any) => {
    setSignature((prev) => ({ ...prev, [attribute]: value }));
    if (!hasFormBeenChanged) setHasFormBeenChanged(true);
  }, []);

  return (
    <div data-cy="portDataList" className={classes.wrapper}>
      {/* <header className="mb-4">
        <Breadcrumb
          items={[
            { title: translate("configurations") },
            {
              title: translate("signature"),
              color: "#465869",
              dataCy: "breadcrumbsSubTitle",
            },
          ]}
        />
      </header> */}
      <section className={classes.section}>
        <Grid container>
          <Grid container item xs={12}>
            <Grid item xs={12} marginBottom="24px">
              <span className={classes.title}>{translate("signature")}</span>
            </Grid>
            <Grid item xs={12} marginBottom="8px">
              <span className={classes.subtitle}>{translate("uploadImage")}</span>
            </Grid>
            <Grid item xs={12} marginBottom="24px">
              <div className={classes.descriptionContainer}>
                <span className={classes.description}>
                  {translate(
                    "thisImageWillBeUsedWhenGeneratingCommercialInvoiceAndPackingListDocumentsBeingUsedAsAnEsignature"
                  )}
                </span>
              </div>
              <SkeletonComponent isLoading={isFetching}>
                <ImageInput
                  id="company-icon"
                  classname={classes.inputImageContainer}
                  title={""}
                  description={translate("uploadYourFile")}
                  logo={logo}
                  onChangeLogo={(logo?: Logo) => {
                    setHasFormBeenChanged(true);
                    setLogo(logo);
                  }}
                  cropImage
                  cropAspectWidth={420}
                  cropAspectHeight={200}
                  cropShape="rect"
                  disabled={isLoading}
                  showActionButtons
                />
              </SkeletonComponent>
            </Grid>
            <Grid container item xs={12}>
              <Grid item xs={12} marginBottom="24px">
                <span className={classes.title}>{translate("details")}</span>
              </Grid>
              <Grid container item xs={12} direction="row" spacing={3}>
                <Grid item xs={12} sm={6} md={3} lg={3}>
                  <SkeletonComponent isLoading={isFetching}>
                    <Input
                      name="name"
                      value={signature?.name}
                      label={translate("name")}
                      onChange={(event) => handleUpdateSignature("name", event.target.value)}
                      placeholder={translate("ayrtonSenna")}
                    />
                  </SkeletonComponent>
                </Grid>
                <Grid item xs={12} sm={6} md={3} lg={3}>
                  <SkeletonComponent isLoading={isFetching}>
                    <Input
                      name="manufacture-position"
                      value={signature?.manufacturePosition}
                      label={translate("positionInManufacturingCompany")}
                      onChange={(event) =>
                        handleUpdateSignature("manufacturePosition", event.target.value)
                      }
                      placeholder={translate("egSupplier")}
                    />
                  </SkeletonComponent>
                </Grid>
                <Grid item xs={12} sm={6} md={3} lg={3}>
                  <SkeletonComponent isLoading={isFetching}>
                    <Input
                      name="manufacture-name"
                      value={signature?.manufactureName}
                      label={translate("nameOfManufacturingCompany")}
                      onChange={(event) =>
                        handleUpdateSignature("manufactureName", event.target.value)
                      }
                      placeholder={translate("egShipeezi")}
                    />
                  </SkeletonComponent>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Box
          className={classes.actionButtons}
          display="flex"
          flexDirection={"row"}
          justifyContent={"flex-end"}
        >
          <ActionButtons
            onSave={onSaveSignature}
            onCancel={onCancelSignature}
            saveDisabled={!hasFormBeenChanged}
            cancelDisabled={isLoading}
            loading={isLoading}
            textSave={translate("save")}
          />
        </Box>
      </section>
    </div>
  );
};

export default SignaturePage;
